import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { GeneralLedgerService } from '../../services/general-ledger.service';
import { GlobalSearchService } from '../../services/globalsearchservice.service';

type GlCloseStatusResponse = {
	success?: boolean;
	closed_through_date?: string | null;
	closed_through_display?: string | null;
	open_from_date?: string | null;
	open_from_display?: string | null;
	message?: string;
};

@Component({
	selector: 'app-gl-close-control',
	templateUrl: './gl-close-control.component.html',
	styleUrls: ['./gl-close-control.component.scss'],
})
export class GlCloseControlComponent implements OnInit {
	color = 'blue';
	selectedDate = '';
	isSaving = false;
	isLoadingStatus = false;
	closedThroughDisplay = 'Not Set';
	openFromDisplay = 'All dates open';

	constructor(
		private glService: GeneralLedgerService,
		private snackBar: MatSnackBar,
		private globalSearchService: GlobalSearchService
	) {
		this.color = this.globalSearchService.getColor();
	}

	ngOnInit(): void {
		this.loadStatus();
	}

	loadStatus(): void {
		this.isLoadingStatus = true;
		this.glService.getGlCloseStatus().subscribe(
			(response: GlCloseStatusResponse) => {
				this.closedThroughDisplay = response?.closed_through_display || 'Not Set';
				this.openFromDisplay = response?.open_from_display || 'All dates open';
				this.isLoadingStatus = false;
			},
			() => {
				this.snackBar.open('Unable to load GL close status.', 'Close', { duration: 3000 });
				this.isLoadingStatus = false;
			}
		);
	}

	closeByDate(): void {
		if (!this.selectedDate) {
			this.snackBar.open('Select a date before closing GL.', 'Close', { duration: 2500 });
			return;
		}
		this.isSaving = true;
		this.glService.closeGlByDate(this.selectedDate).subscribe(
			(response: GlCloseStatusResponse) => {
				this.snackBar.open(response?.message || 'GL closed successfully.', 'Close', { duration: 3000 });
				this.isSaving = false;
				this.loadStatus();
			},
			() => {
				this.snackBar.open('Failed to close GL by date.', 'Close', { duration: 3000 });
				this.isSaving = false;
			}
		);
	}

	reopenByDate(): void {
		if (!this.selectedDate) {
			this.snackBar.open('Select a date before reopening GL.', 'Close', { duration: 2500 });
			return;
		}
		this.isSaving = true;
		this.glService.reopenGlByDate(this.selectedDate).subscribe(
			(response: GlCloseStatusResponse) => {
				this.snackBar.open(response?.message || 'GL reopened successfully.', 'Close', { duration: 3000 });
				this.isSaving = false;
				this.loadStatus();
			},
			() => {
				this.snackBar.open('Failed to reopen GL by date.', 'Close', { duration: 3000 });
				this.isSaving = false;
			}
		);
	}

	back(): void {
		window.history.back();
	}
}
